<div class="legal-content" [innerHTML]="content()"></div>
